import uploadSVG from "../../../assets/upload.svg";
import styles from "./Buttons.module.css";

const ImageInput = ({ id, imageHandler, disabled }) => {
  let className = disabled ? styles.actionButtonDisabled : styles.actionButton;
  return (
    <div className={styles.imageInputDiv}>
      <label htmlFor={id} className={className}>
        <img alt={id} src={uploadSVG} style={{ padding: "5px" }} />
        <input
          style={{ display: "hidden", width: "0" }}
          type="file"
          id={id}
          name="imageLoader"
          accept="image/*"
          onChange={imageHandler}
          multiple
        />
      </label>
    </div>
  );
};

export default ImageInput;
